import { Routes } from '@angular/router';
import { SelfServiceHostComponent } from './components/selfservice-host.component';
import { authGuard } from './services/auth.guard';
import { AUTH_ROUTE_ACCESS } from './config/auth.config';

export const routes: Routes = [
  { path: '', pathMatch: 'full', children: [], canActivate: [authGuard], data: { access: 'public' } },
  {
    path: 'registration',
    component: SelfServiceHostComponent,
    canActivate: [authGuard],
    data: { title: 'User Registration', access: AUTH_ROUTE_ACCESS.registration },
  },
  {
    path: 'auth/error',
    loadComponent: () => import('./components/auth/auth-error.component').then(module => module.AuthErrorComponent),
    canActivate: [authGuard],
    data: { access: 'public' },
  },
  { path: '**', redirectTo: '', data: { access: 'public' } },
];